import client from './client';

//브랜드 검색
export const getBrand = ({ search }) => {

    let urlString = "/search/brand?search=" + encodeURIComponent(search);

    // console.log("getBrand = "+urlString);
    return client.get(urlString);
}

//브랜드 검색 실패시 전시 브랜드 검색
export const getBrandDefault = () => {

    let urlString = "/search/branddefault";

    // console.log("getBrandDefault = "+urlString);
    return client.get(urlString);
}

//브랜드 검색
export const getStat = ({ search }) => {

    let urlString = "/search/stat?search=" + encodeURIComponent(search);

    // console.log("getStat = "+urlString);
    return client.get(urlString);
}

//필터 데이터에 해당하는 브랜드와 상품 검색
export const getBrandProduct = ({ search, brandId, data, type, offset }) => {

    let urlString = "/search/brandproduct?search=" + encodeURIComponent(search) + "&data=" + data + "&type=" + type + "&offset=" + offset + "&brandId=" + brandId;
    /* let brandIdString = "";
    for(var i =0; i < brandId.length ; i++){
        brandIdString = brandIdString +
    } */
    // console.log("getBrandProduct = "+urlString);
    return client.get(urlString);
}

//상품 검색 실패시 전시 브랜드 상품 검색
export const getBrandProductDefault = () => {

    let urlString = "/search/brandproductdefault";

    // console.log("getBrandProductDefault = "+urlString);
    return client.get(urlString);
}

export const getCategoryInfo = ({ search }) => {

    let urlString = "/search/category?search=" + encodeURIComponent(search);
    /* let brandIdString = "";
    for(var i =0; i < brandId.length ; i++){
        brandIdString = brandIdString +
    } */
    // console.log("getBrandProduct = "+urlString);
    return client.get(urlString);
}